export default class Work {
    constructor(
        public readonly name: string,
        public readonly img: string,
        public readonly color: string,
        public readonly images: Array<string> = []
    ) {}
}
